module.exports = __webpack_public_path__ + "static/dna-logo-544fae406491518b2ea152ab6b4e2041.svg";